import { supabase } from "@/integrations/supabase/client";
import { InsuranceType, Address, PersonalInfo } from "@/components/sections/quote/types";

interface SubmitQuoteParams {
  selectedType: InsuranceType;
  address: Address;
  personalInfo: PersonalInfo;
}

export const submitQuote = async ({ 
  selectedType, 
  address, 
  personalInfo 
}: SubmitQuoteParams) => {
  const { error } = await supabase
    .from('quote_leads')
    .insert({
      insurance_type: selectedType,
      street: address.street,
      city: address.city,
      state: address.state,
      zip_code: address.zipCode,
      first_name: personalInfo.firstName,
      last_name: personalInfo.lastName,
      email: personalInfo.email,
      phone: personalInfo.phone,
      lead_source: 'Website Quote Form'
    });

  if (error) throw error;
};